import React from 'react';

import './logo2.css';

import logo from "../../assets/images/logo2/ponos-logo-mark-blue-original.svg";


//  import {Link} from 'react-router-dom';

import { Link as LinkPage, useLocation} from 'react-router-dom'
import { Link as LinkScroll } from 'react-scroll';

const Logo2 = () => {
  const location = useLocation(); // Get current route

const renderLogoLink = () => {
   
    if (location.pathname === '/') {
      return (

         <LinkScroll 
          className="navbar-brand2"
          to="homeNavApp" // Scroll to <div id="home"> on Home page
          smooth={true}
          offset={0}
          duration={500}
         >
           <span className="nav-logo2-content">
          <img className="nav-logo2-img" src={logo} alt="ponos-logo-mark" />
           </span>
            </LinkScroll>
      );
    }
    return (
    

       <LinkPage 
         className="navbar-brand2"
         to={{ pathname: '/', state: { scrollTo: 'homeNavApp' } }}
         onClick={() => {
         
          localStorage.setItem('scrollTo', 'homeNavApp'); // Fallback
         }}
         >
           <span className="nav-logo2-content">
          <img className="nav-logo2-img" src={logo} alt="ponos-logo-mark" />
           </span>
            </LinkPage>
    );
  };


  return (

    // <LinkScroll to='home' className="navbar-brand2">

    //   <span className="nav-logo2-content">
       
    //       <img className="nav-logo2-img" src={logo} alt="ponos-logo-mark" />
          

    //   </span>


    // </LinkScroll>

      <section>
           {renderLogoLink()}
       </section>


  )
}

export default Logo2
